var Request = require('../../helper/request');

function Publish(app, companyId, notificationId){
	var self = this;
	self.app = app;
	self.companyId = companyId;
	self.notificationId = notificationId;
	self.request = new Request(self.app);

	self.routes = {
		index: {
			url: "/company/"+self.companyId+"/notification/"+self.notificationId+"/publish",
			method: "GET"
		},
		create: {
			url: "/company/"+self.companyId+"/notification/"+self.notificationId+"/publish",
			method: "POST"
		}
	};
}

Publish.prototype.index = function(){
	var self = this;
	return self.request.get(self.routes.index.url);
}

/**
*
*	data = {
*		text: "Fitifiti", //Verilen notificationdan bagimsiz bir text olacaksa
*		user_ids: [1, 2, 3], //Belirli userlara atilacaksa
*		platform: "android|ios", //Belirli bir platforma atilacaksa
*		target_group: "category", //Belirli bir category tag veya branch e atilacaksa
*		target: [1], //Belirlenen target group a gore doldurulacak
*		depency: [1], //Bildirim tiklanildiginda gidecek olan post vs var ise 
*	}
*	
**/
Publish.prototype.create = function(data){
	var self = this;
	return self.request.post(self.routes.create.url, {
		publish: data
	});
}

module.exports = Publish;